import { to } from "@lib/utils";
import { Network } from "@models/network";
import { Wallet } from "@models/wallet";
import { ReactNode, useEffect, useState } from "react";
import { connectWalletWC, isMobile, WalletError } from "./services";

const ConnectWalletConnect = ({
  disabled: disabled = false,
  onClick: onClick = () => {},
  onSuccess: onSuccess = () => {},
  onError: onError = (err?: any) => {},
  children,
}: {
  disabled?: boolean;
  onClick?: () => void;
  onSuccess?: (wallet: Wallet) => void;
  onError?: (err?: any) => void;
  children?: ReactNode;
}) => {
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const _mobile = isMobile();
    setMobile(_mobile);
  }, []);

  const connectMobile = async () => {
    try {
      const { err, res: res } = await to(connectWalletWC());
      if (!res?.walletAddress) {
        console.error(err);
        throw WalletError.REQUEST_DENIED;
      }
      const wallet = new Wallet({
        network: Network.EVM,
        address: res.walletAddress,
      });
      console.log("ConnectWalletConnect", wallet);
      return onSuccess(wallet);
    } catch (err) {
      console.error("ConnectWalletConnect connectMobile", err);
      return onError(err);
    }
  };

  return (
    <button
      className="flex flex-row justify-center items-center w-full h-full"
      onClick={mobile ? connectMobile : onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ConnectWalletConnect;
